export function getPointResetCountdown(
  resetAt?: string | null,
  nowMs = Date.now()
) {
  if (!resetAt) {
    return {
      label: 'No active Point cycle',
      remainingSeconds: null,
    }
  }

  const target = new Date(resetAt).getTime()

  if (!Number.isFinite(target)) {
    return {
      label: 'No active Point cycle',
      remainingSeconds: null,
    }
  }

  const remainingMs = target - nowMs

  if (remainingMs <= 0) {
    return {
      label: 'Resetting now',
      remainingSeconds: 0,
    }
  }

  const remainingSeconds = Math.max(
    0,
    Math.ceil(remainingMs / 1000)
  )

  const days = Math.floor(remainingSeconds / 86400)
  const hours = Math.floor((remainingSeconds % 86400) / 3600)
  const minutes = Math.floor((remainingSeconds % 3600) / 60)

  const label =
    days > 0
      ? `${days}d ${hours}h left`
      : hours > 0
        ? `${hours}h ${minutes}m left`
        : `${Math.max(1, minutes)}m left`

  return {
    label,
    remainingSeconds,
  }
}
